<div class="cust-height">
  <div class="col-12 md:col-12">
    <p-table
      #dt
      [selectionMode]="'single'"
      [columns]="listColumns"
      [value]="lastConnect"
      [rows]="100"
      [paginator]="true"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right">{{'Log_Cnx' | translate}} {{'Tot' | translate}} {{ lastConnect.length }} {{'Log_Cnx_1' | translate}}</span>
        </span>
        <button pButton type="button" icon="icons8-trash-can" class="cust-width p-button-danger right"
          pTooltip="{{'Cnx_Del' | translate}}"
          tooltipPosition="left"
          (click)="clickDateDelCnx()"
        ></button>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.sort"
                [ngClass]="{
                    'width-col-13': col.type === 'DateTime',
                    'width-auto': col.type !== 'DateTime'
                }"
              >
              @if (col.sort !== null) {
                <p-sortIcon [field]="col.sort"></p-sortIcon>
              }
              {{ col.header }}
              @if (col.field === 'statecnx') {
                <p-dropdown
                  appendTo="body"
                  [options]="stateList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, col.field, 'equals')"
                ></p-dropdown>
              }
              @if (col.field !== 'statecnx') {
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')"
                  style="color: darkgrey"
                  />
              }
            </th>
          }
          <th style="width: 3em"></th>
        </tr>
      </ng-template>
      <ng-template let-rowData let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData">
          @for (col of columns; track col; let i = $index) {
            <td class="width-auto">
              @switch (col.field) {
                @case ('datecnx') {
                  <div class="align-left">
                    {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </div>
                }
                @case ('statecnx') {
                  <div class="align">
                    @if (rowData[col.field] === 1) {
                      <i class="pi pi-check md-18" style="color: green"></i>
                    }
                    @if (rowData[col.field] === 0) {
                      <i class="pi pi-times md-18" style="color: red"></i>
                    }
                  </div>
                }
                @default {
                  {{ rowData[col.field] }}
                }
              }
            </td>
          }
          <td>
            <i
              class="icons8-trash-can iconstyle"
              (click)="deleteConnect($event, rowData)"
              style="color: red"
            ></i>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">{{'Empty' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  [contentStyle]="{overflow: 'visible', width: '30vw'}"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Cnx_Del' | translate}}
    </span>
    <span class="small">
      {{'Date_Betw' | translate}}
    </span>
  </ng-template>
  <div class="col-12 align">
    <p-calendar placeholder="{{'Range_Date' | translate}}" class="max-w-full" [showButtonBar]="true" [inline]="true" [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"></p-calendar>
  </div>
  <div class="col-12 md:col-12 align-right">
    <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeDia()" label="{{'Cancel' | translate}}"></button>
    <button type="button" pButton class="margin p-button-danger" (click)="clickDelCnx()" label="{{'Delete' | translate}}"></button>
  </div>
</p-dialog>

<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
